/**
 * Utility functions for request tracing
 */

/**
 * Generates a unique datetime identifier for requests
 */
export function generateRequestDateTime(): string {
  return new Date().toISOString()
}

/**
 * Generates a request trace ID for deferred blocks
 * Format: {baseRequestTraceId}:${blockName}-${datetime}
 */
export function generateDeferredBlockTraceId(
  baseRequestTraceId: string,
  blockName: string
): string {
  const datetime = generateRequestDateTime()
  return `${baseRequestTraceId}:${blockName}-${datetime}`
}

/**
 * Generates the initial request trace ID in SSR
 * Format: {pageKey}-{datetime}:{qs_opcional}
 */
export function generateInitialRequestTraceId(
  pageKey: string,
  qsRequestTraceId?: string
): string {
  const datetime = generateRequestDateTime()
  const suffix = qsRequestTraceId ? `:${qsRequestTraceId}` : ''
  return `${pageKey}-${datetime}${suffix}`
}
